import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Chip, Text, Truncated } from '@frontend/design-system';
import { PROVIDER_LANE_WIDTH } from '../constants';

interface Props {
  name: string;
  timezone?: string;
  maxWidth: number;
  columnEntityCount: number;
}

export const LocationBar = ({ name, timezone, maxWidth, columnEntityCount }: Props) => {
  return (
    <div css={[wrapperContainer, { maxWidth }]}>
      <div css={elementsWrapperStyle}>
        <div css={{ display: 'flex', gap: theme.spacing(0.5) }}>
          <Icon name='location-small' color='subdued' />
          <Truncated
            as={Text}
            size='small'
            color='subdued'
            weight='bold'
            css={{ maxWidth: columnEntityCount * PROVIDER_LANE_WIDTH - 105 }} // Adjusted for icon and text spacing/padding
          >
            {name}
          </Truncated>
        </div>
        {!!timezone && <Chip.TimeZone variant='neutral'>{timezone}</Chip.TimeZone>}
      </div>
    </div>
  );
};

const wrapperContainer = css({
  background: theme.colors.neutral5,
  borderBottom: `1px solid ${theme.colors.neutral20}`,
  display: 'flex',
  justifyContent: 'center',
  position: 'sticky',
  left: 0,
});

const elementsWrapperStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  background: theme.colors.neutral5,
  height: 20,
  position: 'sticky',
  left: theme.spacing(1),
  right: theme.spacing(1),
  margin: theme.spacing(0, 2),
});
